<template >
<div id="diario" >
    <v-container fluid fill-height >
        <v-row>
            <span class="logo-normal" >
                <a href="https://www.dof.gob.mx" target="_blank" >
                    <img src="/static/diario-small.png"  alt="DiarioOficial" />
                </a>
            </span>
        </v-row>
        <v-row>
            <v-col cols=2>
                <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                    <template v-slot:activator="{ on }">
                        <v-text-field v-on="on" v-model="fecha_de" label="Fecha de" color="secondary" prepend-icon="event" @blur="fecha_de = parseDate(fecha_de)" v-mask="'####-##-##'" :rules="[rules.required]">
                        </v-text-field>
                    </template>

                    <v-date-picker v-model="fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false">
                        <v-spacer />

                        <v-btn color="secondary" x-small @click="menu1 = false">Cancelar</v-btn>
                    </v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols=2>
                <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                    <template v-slot:activator="{ on }">
                        <v-text-field v-on="on" v-model="fecha_a" label="Fecha a" color="secondary" prepend-icon="event" @blur="fecha_a = parseDate(fecha_a)" v-mask="'####-##-##'" :rules="[rules.required]">
                        </v-text-field>
                    </template>

                    <v-date-picker v-model="fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false">

                        <v-btn color="secondary" x-small @click="menu2 = false">Cancelar</v-btn>
                    </v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols=1>
            <br/>
                <v-btn color="secondary" x-small style="left: 60px;" @click="link">Consultar</v-btn>
            </v-col>
           
        </v-row>

        <v-row>
            <v-layout align-center justify-center>
                <v-flex xs12>
                    <div class="iframe-container">
                        <iframe id="myIframe" :src="$store.state.diario" allowfullscreen></iframe>
                    </div>

                </v-flex>
            </v-layout>
        </v-row>
    </v-container>
</div>
</template>

<script>
import moment from "moment";

export default {
    components: {

    },

    data: () => ({

        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Diario Oficial de la Federación",
                disabled: true,
                to: ""
            },
        ],
        indicador: "",
        fecha_de: "",
        fecha_a: "",
        menu2: false,
        menu1: false,
        rules: {
            required: (v) => !!v || "Este campo es requerido",
            numeric: (value) => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            },
        },
        indicadores: [{
                id: "158",
                text: "DOLAR"
            },
            {
                id: "159",
                text: "UDIS"
            },
            {
                id: "160",
                text: "CCP"
            },
            {
                id: "161",
                text: "CCP-UDIS"
            },
            {
                id: "162",
                text: "CPP"
            },
            {
                id: "163",
                text: "CCP-DOLARES"
            },
            {
                id: "165",
                text: "TIIE 28 DIAS"
            },
            {
                id: "166",
                text: "TIIE 91 DIAS"
            },
            {
                id: "167",
                text: "TIIC DEPOSITOS 60 DIAS"
            },
            {
                id: "168",
                text: "TIIC DEPOSITOS 90 DIAS"
            },
            {
                id: "169",
                text: "TIIC DEPOSITOS 180 DIAS"
            },
            {
                id: "170",
                text: "TIIC PAGARES 28 DIAS"
            },
            {
                id: "171",
                text: "TIIC PAGARES 91 DIAS"
            },
            {
                id: "172",
                text: "TIIC PAGARES 182 DIAS"
            },
            {
                id: "174",
                text: "TIIE 182 DIAS"
            },
            {
                id: "175",
                text: "TIIE DE FONDEO"
            },
            {
                id: "176",
                text: "TIIE 90 DIAS"
            },
            {
                id: "177",
                text: "TIIE 29 DIAS"
            },
            {
                id: "178",
                text: "TIIE 27 DIAS"
            },
            {
                id: "179",
                text: "TIIE 26 DIAS"
            },
        ],

    }),
    watch: {
        "this.$store.state.diario"() {
            this.reload();
        }
    },
    created() {
        this.indicador = "158";
        var f_a = new Date();
        let y = f_a.getFullYear();
        let m = f_a.getMonth() + 1;
        let d = f_a.getDate();
        if (m < 10) m = "0" + m;
        if (d < 10) d = "0" + d;
        let fecha = y + "-" + m + "-" + d;
        this.fecha_de = fecha;
        this.fecha_a = fecha;
        let fa = this.fecha_a.split("-");
        let fd = this.fecha_de.split("-");
        this.$store.state.diario = "https://www.dof.gob.mx/indicadores_detalle.php?cod_tipo_indicador=" +
            this.indicador + "&dfecha=" + fd[2] + "%2F" + fd[1] + "%2F" + fd[0] + "&hfecha=" + fa[2] + "%2F" + fa[1] + "%2F" + fa[0] + "";
    },
    methods: {
        reload() {
            var myIFrame = document.getElementById("myIframe");
            myIFrame.src = "";
            myIFrame.src = this.$store.state.diario;
            var frameDocument = myIFrame.contentDocument ? myIFrame.contentDocument : myIFrame.contentWindow.document;

        },
        parseDate(date) {
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },

        link: function () {

            let fa = this.fecha_a.split("-");
            let fd = this.fecha_de.split("-");
            this.$store.state.diario = "https://www.dof.gob.mx/indicadores_detalle.php?cod_tipo_indicador=" +
                this.indicador + "&dfecha=" + fd[2] + "%2F" + fd[1] + "%2F" + fd[0] + "&hfecha=" + fa[2] + "%2F" + fa[1] + "%2F" + fa[0] + "";

        }
    }

};
</script>

<style scoped>
.iframe-container {

    padding-top: 56.25%;
    position: relative;
    overflow: hidden;
}

.iframe-container iframe {
    border: 0;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
}
</style>
